import axios from "../axiosConfig";

class Routes {
  getUser(id) {
    return axios.get(`/user/${id}`);
  }
  getAllUsers() {
    return axios.get(`/user`);
  }
  updateUser(id, data) {
    return axios.patch(`/user/${id}`, data);
  }

  userPoints(id) {
    return axios.get(`/user/points/${id}`);
  }

  verifyXevoraAPI() {
    return axios.get(`/user/verify/xevora-api`);
  }
}

export default new Routes();
